module.exports = __webpack_public_path__ + "static/media/two_business.5efcb436.svg";